import React, { useCallback, useState } from 'react'
import { Dropdown, Menu, Switch, Table, Typography } from 'antd'
import { formatDate } from '../../utils/date-format'
import _ from 'lodash'
import { DownOutlined } from '@ant-design/icons'
import { EditApplicationPaymentModal } from '../application/ApplicationPaymentModal'
import { formatMoney } from '../../utils/number-utils'

const { Text } = Typography

const PaymentTable = ({ ds, refreshHandler }) => {
  const [showPaymentModal, setShowPaymentModal] = useState(false)
  const [paymentId, setPaymentId] = useState(null)

  const onPaymentShowHandler = useCallback(
    (id) => () => {
      setPaymentId(id)
      setShowPaymentModal(true)
    },
    []
  )

  const onPaymentCloseHandler = useCallback(() => {
    setShowPaymentModal(false)
    setPaymentId(null)
  }, [])

  const onPaymentApplyHandler = useCallback(() => {
    onPaymentCloseHandler()
    refreshHandler()
  }, [refreshHandler])

  const columns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
      align: 'right',
      width: 5,
    },
    {
      title: 'Дата оплаты',
      dataIndex: 'pay_date',
      key: 'pay_date',
      render: formatDate,
      width: 30,
    },
    {
      title: 'Пользователь',
      dataIndex: 'user',
      key: 'user',
      align: 'left',
      width: 50,
      render: (user) => `${user?.second_name} ${user?.first_name} (${user?.email})`,
    },
    {
      title: 'Платёж',
      dataIndex: 'paid',
      key: 'paid',
      align: 'right',
      width: 20,
      render: (value) => formatMoney(value),
    },
    {
      title: 'Оплачено полностью',
      dataIndex: 'is_full',
      key: 'is_full',
      align: 'center',
      width: 10,
      render: (value) => <Switch checked={value} />,
    },
    {
      title: 'Комментарий',
      dataIndex: 'description',
      key: 'description',
      align: 'left',
      width: 30,
    },
    {
      title: 'Операции',
      dataIndex: 'id',
      key: 'operations',
      width: 100,
      render: (id) => {
        const menu = (
          <Menu>
            <Menu.Item key="edit" type="dashed" onClick={onPaymentShowHandler(id)}>
              Редактировать
            </Menu.Item>
          </Menu>
        )
        return (
          <Dropdown overlay={menu}>
            <a>
              Действия <DownOutlined />
            </a>
          </Dropdown>
        )
      },
    },
  ]

  return (
    <div>
      <Table
        style={{ paddingTop: 20 }}
        columns={columns}
        pagination={false}
        dataSource={ds}
        bordered
        summary={(data) => {
          const isFull = data?.some(({ is_full }) => is_full && is_full)
          const paid = _.sum(data?.map((p) => p.paid))
          const info = data && data.length > 0 && (isFull ? 'Оплачено полностью' : 'Оплачено частично')
          return (
            <Table.Summary>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={3} align="right">
                  <Text strong type={isFull ? 'success' : 'warning'}>
                    {info}
                  </Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} align="right">
                  <Text strong>{formatMoney(paid)}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} colSpan={3} />
              </Table.Summary.Row>
            </Table.Summary>
          )
        }}
      />
      <EditApplicationPaymentModal
        showModal={showPaymentModal}
        paymentId={paymentId}
        onCancel={onPaymentCloseHandler}
        onFinish={onPaymentApplyHandler}
      />
    </div>
  )
}

export default PaymentTable
